export default "/images/favourite-small-standard.svg?5a2b72c0ccc87978104aa4d132751068";